import classNames from "classnames";
import React from "react";

import Button from "@atoms/Button";
import Image from "@atoms/Image";

interface IProps {
  position?: "center" | "bottom";
  src: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  className?: string;
}

export default function ColorSelector({ src, onClick, className, position }: IProps) {
  return (
    <Button as="wrapper" className={classNames("relative isolate overflow-hidden", className)} onClick={onClick}>
      <span
        className={classNames(
          "absolute left-1/2 size-full -translate-x-1/2",
          position === "bottom" ? "bottom-[90%]" : "top-1/2 -translate-y-1/2",
        )}
      >
        <Image className="pointer-events-none scale-250" src={src} />
      </span>
    </Button>
  );
}
